import { render, staticRenderFns } from "./ProviderButton.vue?vue&type=template&id=3a9d87ff&scoped=true&"
import script from "./ProviderButton.vue?vue&type=script&lang=ts&"
export * from "./ProviderButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderButton.vue?vue&type=style&index=0&id=3a9d87ff&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9d87ff",
  null
  
)

export default component.exports